<template>
  <!-- CONFIRMATION MODAL -->
  <v-dialog persistent v-model="showDialog" max-width="450">

    <!-- BUTTON WITH TOOLTIP -->
    <template v-slot:activator="{ props: dialogProps }" >
      <v-tooltip :text="`Delete '${props.item.name}'`" location="top">
        <template v-slot:activator="{ props: tooltipProps }">
          <v-btn
              v-bind="dialogProps, tooltipProps"
              class="mx-1"
              size="small"
              rounded
              flat
              height="35px"
              min-width="35px"
              max-width="35px"
              color="red-darken-2"
          >
            <i class="fas fa-trash" />
          </v-btn>
        </template>
      </v-tooltip>
    </template>

    <!-- MODAL CARD -->
    <v-card>
      <v-card-title><b>Confirm Delete</b></v-card-title>
      <v-divider/>
      <v-card-text>You're about to delete {{ props.itemType }} "{{props.item.name}}". This action cannot be undone.</v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue" rounded @click="showDialog = false">Cancel</v-btn>
        <v-btn color="red" class="px-4" variant="flat" rounded @click="sendDeleteRequest">
          <v-progress-circular class="mr-3" size="small" v-if="isLoading" indeterminate />
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
  import {ref} from "vue";
  import {router} from "@inertiajs/vue3";
  import * as $routes from "@/packs/routes";

  /**
   * Usually, this prop is referring to a database object. A `Project`, a `KPI`, a `PSI`; stuff like that.
   * In this specific component, it's important that this object has **ID** and **Name** attributes.
   */
  const props = defineProps({
    item: {
      type: Object,
      required: true
    },

    /**
     * A descriptive name for the type it's passed. E.g. "KPI" or "Project".
     */
    itemType: {
      type: String,
      required: true
    },

    /**
     * The targeted route of the button. When pressed, the button will send a DELETE request to this route.
     */
    route: {
      type: String,
      required: true
    },

    /**
     * The route that the user will be redirected to whenever the task is successful.
     */
    successFallback: {
      type: String,
      required: false
    }
  });

  const showDialog = ref(false);
  const isLoading = ref(false);

  const sendDeleteRequest = () => {
    isLoading.value = true;

    router.delete(props.route, {
      onSuccess: () => {
        if (props.successFallback)
          router.visit(props.successFallback);

        isLoading.value = false;
      }
    });
  };

</script>
